import styles from './organisation-area-groups-overlay.module.scss';

import { Table } from '@tanstack/react-table';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useDialogs } from '@work4all/components';
import { NavigationOverlay } from '@work4all/components/lib/navigation/navigation-overlay';

import { Group } from '@work4all/models/lib/Classes/Group.entity';

import { MaskContextProvider } from '../../../containers/mask-overlays/mask-overlay/hooks/mask-context';
import { createHandleColumnFilterChange } from '../../data-tables/table-quick-filters/utils';
import { useOrganisationAreaContext } from '../hooks';

import { OrganisationAreaGroupsPage } from './organisation-area-groups-page';

export const OrganisationAreaGroupsOverlay = ({
  table,
}: {
  table: Table<unknown>;
}) => {
  const dialogs = useDialogs();

  const { isGroupsEditOverlayOpen, setGroupsEditOverlayOpen } =
    useOrganisationAreaContext();

  const { t } = useTranslation();

  const [isDirty, setIsDirty] = useState(false);

  if (!isGroupsEditOverlayOpen) return null;

  const handleClose = async () => {
    if (isDirty) {
      const confirmed = await dialogs.confirm({
        title: t('ALERTS.CONFIRM'),
        description: t('ALERTS.ABORT_MESSAGE'),
        confirmLabel: t('MASK.GROUP_MANAGEMENT.DIALOG.ABORT'),
        cancelLabel: t('ALERTS.NO'),
      });

      if (!confirmed) {
        return;
      }
    }
    setIsDirty(false);
    setGroupsEditOverlayOpen(false);
  };

  const groupColumnFilterValue = table
    .getColumn('groupId')
    .getFilterValue() as any;

  const handleGroupsChange = createHandleColumnFilterChange<Group>(
    table.getColumn('groupId')
  );

  const filteredColumns = groupColumnFilterValue?.value as
    | {
        id: number;
      }[]
    | null;

  return (
    <MaskContextProvider
      value={{
        entity: undefined,
        isCreateMode: false,
        isEditMode: false,
        mode: 'edit',
        params: null,
        wip: false,
      }}
    >
      <NavigationOverlay
        open={isGroupsEditOverlayOpen}
        initialView={{
          title: t('COMMON.FILTERS'),
          view: (
            <OrganisationAreaGroupsPage
              filteredColumns={filteredColumns}
              handleGroupsChange={handleGroupsChange}
              setIsDirty={setIsDirty}
            />
          ),
        }}
        close={handleClose}
        classes={{ wrapper: styles.wrapper }}
      />
    </MaskContextProvider>
  );
};
